import 'element-plus/dist/index.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import {Search,Menu as MenuIcon,ChatRound} from '@element-plus/icons-vue'
import VueLazyload from 'vue-lazyload'

const app = createApp(App)

app.use(router)
app.use(ElementPlus)
app.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1
})
app.component('Search', Search)
app.component('MenuIcon', MenuIcon) 
app.component('ChatRound', ChatRound)
app.mount('#app')

